"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shortenRegion = shortenRegion;
exports.awsPlatform = awsPlatform;
exports.isLambda = isLambda;
exports.isECS = isECS;
const platform = {
    awsAccessKeyId: undefined,
    awsLambdaFunctionName: undefined,
    awsRegion: undefined,
    awsRegionShort: undefined,
    awsSecretAccessKey: undefined,
    awsSessionToken: undefined,
};
function shortenRegion(region) {
    if (region === undefined) {
        return undefined;
    }
    const re = /^([^-]*)-(.)(?:o[ru]th|[ae]st|entral)(.?)[^-]*-(.*)$/;
    const arr = re.exec(region);
    return arr != null ? arr.slice(1).join('') : undefined;
}
function awsPlatform() {
    platform.awsAccessKeyId = process.env.AWS_ACCESS_KEY_ID;
    platform.awsLambdaFunctionName = process.env.AWS_LAMBDA_FUNCTION_NAME;
    platform.awsRegion = process.env.AWS_REGION;
    platform.awsSecretAccessKey = process.env.AWS_SECRET_ACCESS_KEY;
    platform.awsSessionToken = process.env.AWS_SESSION_TOKEN;
    platform.awsAccountId = process.env.AWS_ACCOUNT_ID;
    if (!platform.awsRegionShort) {
        platform.awsRegionShort = shortenRegion(platform.awsRegion);
    }
    return platform;
}
/**
 * Returns true if the current environment is running on a lambda function.
 * @returns {boolean}
 */
function isLambda() {
    return process.env.LAMBDA_TASK_ROOT !== undefined;
}
/**
 * Returns true if the current environment is running on a ECS cluster.
 * @returns {boolean}
 */
function isECS() {
    return (process.env.AWS_EXECUTION_ENV === 'AWS_ECS_FARGATE' ||
        process.env.AWS_EXECUTION_ENV === 'AWS_ECS_EC2');
}
//# sourceMappingURL=platform.js.map